namespace Solovis.Reports.Layouts {

  export class GridLayoutPart extends LayoutPart {

    constructor(options) {
      super(options);
    }

    public createPart(parentElement) {
      var self = this;

      this.layoutDiv = $("<div>").addClass("report-grid-layout").appendTo(parentElement)
        .css("display", "none");

      if (this.partDefinition.style) {
        this.reportControl._applyStyleToPartContainer(this.partDefinition.style, this.layoutDiv);
      }

      const isDashboard = (window as any).PageViewModel.isDashboard
      const isModern = self.options.renderMode === 'modern';

      if (this.partDefinition.children) {
        $(this.partDefinition.children).each(function (i, child) {
          const horizontalBlockClass = isDashboard && isModern ? 'slvs-panel tw-p-4' : 'report-grid-block';
          var horizontalBlock = $("<div>").addClass(horizontalBlockClass).appendTo(self.layoutDiv);
          var childPart = self.reportControl._createPartContainer({ parentElement: horizontalBlock, partDefinition: child });
          self.childPartList.push(childPart);
        });
      }
    };
  }
}